import Landcover4ReviewSingle from "./pages/ReviewSingle";
import Landcover4ReviewSummary from "./pages/ReviewSummary";
import SummarySuperuser from "./pages/SummarySuperuser";
import Landcover4Task from "./pages/Task";

const routes = [
  { path: "task", element: Landcover4Task },
  { path: "review", element: Landcover4ReviewSummary },
  { path: "review/single", element: Landcover4ReviewSingle },
  { path: "superuser", element: SummarySuperuser },
];
export default routes;
